"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rotatePoint = exports.lineIntersect = void 0;
/**
 * Calculates intersection between 2 lines (x1,y1,x2,y2 - coordinates of the first line, x3,y3,x4,y4 - coordinates of the second line)
 * @param x1 x coordinate of the line 1 starting point
 * @param y1 y coordinate of the line 1 starting point
 * @param x2 x coordinate of the line 1 ending point
 * @param y2 y coordinate of the line 1 ending point
 * @param x3 x coordinate of the line 2 starting point
 * @param y3 y coordinate of the line 2 starting point
 * @param x4 x coordinate of the line 2 ending point
 * @param y4 y coordinate of the line 2 ending point
 *
 * returns: x & y of the intersection point and whether lines insterect along the segments
 *          if returns null - then lines doesn't intersect
 */
const lineIntersect = (x1, y1, x2, y2, x3, y3, x4, y4) => {
    let ua, ub, denom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
    if (denom === 0) {
        return null;
    }
    ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denom;
    ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denom;
    return {
        x: x1 + ua * (x2 - x1),
        y: y1 + ua * (y2 - y1),
        seg1: ua >= 0 && ua <= 1,
        seg2: ub >= 0 && ub <= 1,
    };
};
exports.lineIntersect = lineIntersect;
const rotatePoint = (point, origin, angle) => {
    const p = { x: point.x, y: point.y };
    const s = Math.sin(angle);
    const c = Math.cos(angle);
    // translate point back to origin:
    p.x -= origin.x;
    p.y -= origin.y;
    // rotate point
    const xnew = p.x * c - p.y * s;
    const ynew = p.x * s + p.y * c;
    // translate point back:
    p.x = xnew + origin.x;
    p.y = ynew + origin.y;
    return p;
};
exports.rotatePoint = rotatePoint;
